export const menuGroups = [
    {
        name: '钻具成品',
        authName: "product",
        children: [
            {
                name: '成品分类',
                authName: "productTemplateList",
                path: '/product_templates',
                module: 'product_template'
            },
            {
                name: '成品列表',
                authName: "productList",
                path: '/products',
                module: 'product'
            },
            {
                name: '使用记录',
                authName: "productDisassemble",
                path: '/product_records',
                module: 'product_record'
            },
            {
                name: '数据统计',
                authName: "productStatistics",
                path: '/product_statistics',
                module: 'product_statistics'
            }
        ]
    },
    {
        name: '钻具配件',
        authName: "item",
        children: [
            {
                name: '配件分类',
                authName: "itemTemplateList",
                path: '/item_templates',
                module: 'item_template'
            },
            {
                name: '配件列表',
                authName: "itemList",
                path: '/items',
                module: 'item'
            },
            {
                name: '数据统计',
                authName: "itemStatistics",
                path: '/item_statistics',
                module: 'item_statistics'
            }
        ]
    },
    {
        name: '仪器成品',
        authName: "instrument",
        children: [
            {
                name: '成品分类',
                authName: "instrumentTemplateList",
                path: '/instrument_templates',
                module: 'instrument_template'
            },
            {
                name: '成品列表',
                authName: "instrumentList",
                path: '/instruments',
                module: 'instrument'
            },
            {
                name: '无编号成品',
                authName: "instrumentList",
                path: '/group_instruments',
                module: 'group_instrument'
            },
            {
                name: '库存分布',
                authName: "instrumentInventoryList",
                path: '/instrument_inventories',
                module: 'instrument_inventory'
            },
            {
                name: '使用记录',
                authName: "instrumentDisassemble",
                path: '/instrument_records',
                module: 'instrument_record'
            },
            // {
            //     name: '钻井使用统计',
            //     authName: "instrumentWellPeriodList",
            //     path: '/instrument_well_periods',
            //     module: 'instrument_well_period'
            // },
            {
                name: '数据统计',
                authName: "instrumentStatistics",
                path: '/instrument_statistics',
                module: 'instrument_statistics'
            }
        ]
    },
    {
        name: '仪器配件',
        authName: "instrumentItem",
        children: [
            {
                name: '配件分类',
                authName: "instrumentItemTemplateList",
                path: '/instrument_item_templates',
                module: 'instrument_item_template'
            },
            {
                name: '配件列表',
                authName: "instrumentItemList",
                path: '/instrument_items',
                module: 'instrument_item'
            },
            {
                name: '库存分布',
                authName: "instrumentItemInventoryList",
                path: '/instrument_item_inventories',
                module: 'instrument_item_inventory'
            },
            {
                name: '数据统计',
                authName: "instrumentItemStatistics",
                path: '/instrument_item_statistics',
                module: 'instrument_item_statistics'
            }
        ]
    },
    {
        name: '物资申请',
        authName: "materialTransfer",
        children: [
            {
                name: '我的申请',
                authName: "applyNew",
                path: '/my_applies',
                module: 'my_apply'
            },
            {
                name: '待审批的申请',
                authName: "applyApprove",
                path: '/approve_applies',
                module: 'approve_apply'
            },
            {
                name: '所有申请',
                authName: "applyList",
                path: '/applies',
                module: 'apply'
            },
        ]
    },
    {
        name: '物资调拨',
        authName: "supplyTransfer",
        children: [
            {
                name: '接收列表',
                authName: "supplyReceiveList",
                path: '/my_supplies',
                module: 'my_supply'
            },
            {
                name: '调拨列表',
                authName: "supplyList",
                path: '/supplies',
                module: 'supply'
            },
        ]
    },
    {
        name: '基地管理',
        authName: "base",
        children: [
            {
                name: '基地列表',
                authName: "baseList",
                path: '/bases',
                module: 'base'
            },
        ]
    },
    {
        name: '钻井管理',
        authName: "drillWell",
        children: [
            {
                name: '钻井列表',
                authName: "drillWellList",
                path: '/drill_wells',
                module: 'drill_well'
            },
        ]
    },
    {
        name: '用户管理',
        authName: "user",
        children: [
            {
                name: '用户列表',
                authName: "userList",
                path: '/users',
                module: 'user'
            },
            {
                name: '角色列表',
                authName: "roleList",
                path: '/roles',
                module: 'role'
            },
        ]
    },
]